<template>
  <section class="page container py-5">
    <h1 class="mb-3">My Centre</h1>
    <p class="mb-4">
      This is a placeholder page. If you have a login/portal URL, we can link it here or embed it.
    </p>
    <a class="btn btn-danger" href="#" @click.prevent>
      Configure My Centre link
    </a>
  </section>
</template>

<script>
export default {
  name: 'MyCentrePage'
}
</script>
